import React from "react";

const Ouriti = () => {
  const services = [
    { icon: "fa fa-graduation-cap", title: "Skilled Instructors" },
    { icon: "fa fa-globe", title: "Online Classes" },
    { icon: "fa fa-home", title: "Home Projects" },
    { icon: "fa fa-book", title: "Book Library" },
  ];

  return (
    <div className="container py-5">
      <h2 className="text-primary mb-5 text-center">Our Services</h2>
      <div className="row g-4">
        {services.map((s, i) => (
          <div className="col-lg-3 col-md-6" key={i}>
            <div className="service-item text-center p-4">
              <i className={`${s.icon} fa-3x text-primary mb-4`}></i>
              <h5>{s.title}</h5>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Ouriti;
